// Shared by the parent's and the driver's bus screens: a state as a coloured line with a dot (not a
// pill), and a stop's planned time as people read it.
export type Tone = "neutral" | "info" | "success" | "warning" | "danger";

/** "07:45" as people read it: "7:45 AM". */
export const clock = (hhmm: string | null) => {
  if (!hhmm) return null;
  const [h, m] = hhmm.split(":").map(Number) as [number, number];
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

/** A moment on the phone's own clock: the driver reads it against the dashboard, not the school's time zone. */
export const phoneClock = (ms: number) => new Date(ms).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

/** A state as a coloured line with a dot, pulsing while something is live. */
export function Status({ tone, live, children }: { tone: Tone; live?: boolean; children: string }) {
  return <p className="pmt-status" data-tone={tone} data-live={live || undefined}><span className="pmt-status__dot" aria-hidden="true" />{children}</p>;
}
